import { Star } from "lucide-react";

export function Stars({ value = 0, size = "h-4 w-4", onChange, testId }) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => {
        const icon = <Star className={`${size} ${n <= Math.round(value) ? "fill-[#FF9F1C] text-[#FF9F1C]" : "fill-neutral-200 text-neutral-200"}`} />;
        return onChange
          ? <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star`} data-testid={`${testId}-${n}`} className="transition-transform duration-150 hover:scale-110">{icon}</button>
          : <span key={n}>{icon}</span>;
      })}
    </span>
  );
}

export function RatingBadge({ avg, count, testId }) {
  if (!count) return null;
  return (
    <span className="inline-flex items-center gap-1 text-sm font-semibold text-neutral-800" data-testid={testId}>
      <Star className="h-4 w-4 fill-[#FF9F1C] text-[#FF9F1C]" />{avg.toFixed(1)}<span className="font-normal text-neutral-500">({count})</span>
    </span>
  );
}
